import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

export interface IOption<T = string | number> {
  id: T;
  label: string;
  disabled?: boolean;
  selected?: boolean;
  tooltip?: string | null;
  labelClass?: string | null;
  /** Vysvětlení zakázané položky (disabled) při najetí myší; bez něj výchozí text komponenty (ui-multiselect-checkbox). */
  disabledHint?: string | null;
}

// connects form elements with parent form if they are content projected
// for submit state
@Injectable()
export class FormConnectorService {
  submitted$ = new ReplaySubject<boolean>(1);
}
